// FETCH ALL PCS_WEIGHT
export const FETCH_PCS_WEIGHT_REQUEST = 'FETCH_PCS_WEIGHT_REQUEST';
export const FETCH_PCS_WEIGHT_SUCCESS = 'FETCH_PCS_WEIGHT_SUCCESS';
export const FETCH_PCS_WEIGHT_FAILURE = 'FETCH_PCS_WEIGHT_FAILURE';

export const FETCH_PCS_WEIGHT_PART_COLOR_REQUEST = 'FETCH_PCS_WEIGHT_PART_COLOR_REQUEST';
export const FETCH_PCS_WEIGHT_PART_COLOR_SUCCESS = 'FETCH_PCS_WEIGHT_PART_COLOR_SUCCESS';
export const FETCH_PCS_WEIGHT_PART_COLOR_FAILURE = 'FETCH_PCS_WEIGHT_PART_COLOR_FAILURE';

export const FETCH_PCS_WEIGHT_PART_DETAIL_INFO_REQUEST = 'FETCH_PCS_WEIGHT_PART_DETAIL_INFO_REQUEST';
export const FETCH_PCS_WEIGHT_PART_DETAIL_INFO_SUCCESS = 'FETCH_PCS_WEIGHT_PART_DETAIL_INFO_SUCCESS';
export const FETCH_PCS_WEIGHT_PART_DETAIL_INFO_FAILURE = 'FETCH_PCS_WEIGHT_PART_DETAIL_INFO_FAILURE';


export const FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_REQUEST = 'FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_REQUEST';
export const FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_SUCCESS = 'FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_SUCCESS';
export const FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_FAILURE = 'FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_FAILURE';


// CREATE PCS_WEIGHT
export const CREATE_PCS_WEIGHT_REQUEST = 'CREATE_PCS_WEIGHT_REQUEST';
export const CREATE_PCS_WEIGHT_SUCCESS = 'CREATE_PCS_WEIGHT_SUCCESS';
export const CREATE_PCS_WEIGHT_FAILURE = 'CREATE_PCS_WEIGHT_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_PCS_WEIGHT_REQUEST = 'FETCH_SINGLE_PCS_WEIGHT_REQUEST';
export const FETCH_SINGLE_PCS_WEIGHT_SUCCESS = 'FETCH_SINGLE_PCS_WEIGHT_SUCCESS';
export const FETCH_SINGLE_PCS_WEIGHT_FAILURE = 'FETCH_SINGLE_PCS_WEIGHT_FAILURE';

// UPDATE PCS_WEIGHT
export const UPDATE_PCS_WEIGHT_REQUEST = 'UPDATE_PCS_WEIGHT_REQUEST';
export const UPDATE_PCS_WEIGHT_SUCCESS = 'UPDATE_PCS_WEIGHT_SUCCESS';
export const UPDATE_PCS_WEIGHT_FAILURE = 'UPDATE_PCS_WEIGHT_FAILURE';

// DELETE PCS_WEIGHT
export const DELETE_PCS_WEIGHT_REQUEST = 'DELETE_PCS_WEIGHT_REQUEST';
export const DELETE_PCS_WEIGHT_SUCCESS = 'DELETE_PCS_WEIGHT_SUCCESS';
export const DELETE_PCS_WEIGHT_FAILURE = 'DELETE_PCS_WEIGHT_FAILURE';

export const FETCH_PROGRAM_MAPPING_BY_NAME_REQUEST = 'FETCH_PROGRAM_MAPPING_BY_NAME_REQUEST';
export const FETCH_PROGRAM_MAPPING_BY_NAME_SUCCESS = 'FETCH_PROGRAM_MAPPING_BY_NAME_SUCCESS';
export const FETCH_PROGRAM_MAPPING_BY_NAME_FAILURE = 'FETCH_PROGRAM_MAPPING_BY_NAME_FAILURE';

export const RESET_PCS_WEIGHT_INFO = 'RESET_PCS_WEIGHT_INFO';

export const CREATE_PCS_WEIGHT_FORM = 'CREATE_PCS_WEIGHT_FORM';

export const UPDATE_PCS_WEIGHT_FORM = 'UPDATE_PCS_WEIGHT_FORM';

export const FETCH_PCS_WEIGHT_DROPDOWN_UPDATE_REQUEST = 'FETCH_PCS_WEIGHT_DROPDOWN_UPDATE_REQUEST';
export const FETCH_PCS_WEIGHT_DROPDOWN_UPDATE_SUCCESS = 'FETCH_PCS_WEIGHT_DROPDOWN_UPDATE_SUCCESS';
export const FETCH_PCS_WEIGHT_DROPDOWN_UPDATE_FAILURE = 'FETCH_PROGRAM_MAPPING_BY_NAME_FAILURE';

export const FORCE_RENDER_DELETE_UPDATE = 'FORCE_RENDER_DELETE_UPDATE';

